// defined in Alaska at https://gitlab.eventops.io/athlinks/start/blob/master/Athlinks.ClassLib/library/Types/Status.cs

export enum EventStatus {
  NotSet = -1,
  Declined = 0,
  Approved = 1,
  Hidden = 2,
  Rejected = 3,
  Pending = 4,
  Merged = 5
}